import { inits } from '@common/models';
import type { Types } from '@common/models';
import { tuneSubscribe } from '@common/talkn-config';
import Sequence from '@common/Sequence';

type Action = {
  type: string;
  tuneCh: Types['Ch'];
  posts: Types['Post'][];
};

const isStaleLiveUpdate = (state: Types['Ch'], action: Action): boolean => {
  const incomingRevision = Number(action.tuneCh?.liveRevision ?? 0);
  const currentRevision = Number(state.liveRevision ?? 0);
  return Boolean(incomingRevision && currentRevision > incomingRevision);
};

export default (state: Types['Ch'] = inits.ch, action: Action) => {
  switch (action.type) {
    case `${Sequence.SERVER_TO_API_BROADCAST}${tuneSubscribe.statePosts}`:
      // 配列境界チェック: postsが存在し、少なくとも1つの要素がある場合のみ更新
      if (action.posts && action.posts.length > 0 && action.posts[0]) {
        return { ...state, latestPost: action.posts[0] };
      }
      break;
    default:
      if (action.tuneCh) {
        if (isStaleLiveUpdate(state, action)) return state;
        if (state.connection === action.tuneCh.connection && action.tuneCh.meta) {
          // Only update liveCnt for tune/untune events; other events (e.g. fetchChDetail)
          // carry liveCnt=0 from inits.ch defaults and must not override the real count.
          // Action types use colon separator: SERVER_TO_API[BROADCAST]:tune
          const isTuneOrUntune = action.type.endsWith(':tune') || action.type.endsWith(':untune');
          return {
            ...state,
            liveCnt: isTuneOrUntune ? (action.tuneCh.liveCnt ?? state.liveCnt) : state.liveCnt,
            meta: action.tuneCh.meta,
          };
        }
        if (state.tuneId === '' && action.tuneCh.tuneId) {
          return { ...action.tuneCh };
        }
        if (state.tuneId !== '' && state.tuneId === action.tuneCh.tuneId) {
          // Preserve existing meta if incoming tuneCh doesn't have it
          const meta = action.tuneCh.meta || state.meta;
          return { ...action.tuneCh, meta };
        }
        if (state.connection === action.tuneCh.connection) {
          const meta = action.tuneCh.meta || state.meta;
          return { ...state, liveCnt: action.tuneCh.liveCnt, meta };
        }
      }
      break;
  }

  return state;
};
